import { render } from "./OutlineResources.vue?vue&type=template&id=b3652f54"
import script from "./OutlineResources.vue?vue&type=script&lang=js"
export * from "./OutlineResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__